export default {
  en: {
    TeamIndexScene: {
      title: 'Users',
      addNew: 'New user',
    },
  },
};
